export default __webpack_public_path__ + "static/media/fs-project-2.c4263a17.png";